<div class="container mt-4">
  <div class="alert text-center mt-3 bg-primary text-dark">
    <i class="bi bi-ban-fill d-block h1"></i> {{ 'UNAUTHORIZED' | translate }}
  </div>
</div>
